export const useDefaultData = () => {

    const defaultDataModal = {
        open: false,
        titleModal: '',
        componentModal: '',
        dataRequest: {},
    }

    const defaultFormScreen = {
        idcasa: '',
        descripcion_corta: '',
        descripcion_larga: '',
        direccion: '',
        costo_alquiler: '',
    }

    return Object.freeze({
        defaultDataModal,
        defaultFormScreen
    })
}